import api from './index';

export const fetchRespondents = async (params) => {
  const result = await api.get(`/respondents`, params);
  return result;
};

export const fetchRespondent = async (id) => {
  const result = await api.get(`/respondents/${id}`);
  return result;
};

export const addRespondent = async (respondent) => {
  const result = await api.post(`/respondents`, respondent);
  return result;
};

export const updateRespondent = async (id, data) => {
  const result = await api.patch(`/respondents/${id}`, data);
  return result;
};

export const deleteRespondents = async (respondentsIds) => {
  const result = await api.delete(`/respondents`, undefined, respondentsIds);
  return result;
};

export const importRespondents = async (respondents) => {
  const result = await api.post(`/respondents/import/respondents`, respondents);
  return result;
};
